import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Phoenix Project recap",
  "description": "",
  "published": "2019-05-19T00:00:00.000Z",
  "redirect_from": ["/blog/the-phoenix-project-recap/swizec/9086"],
  "categories": "Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On my run today I finally finished The Phoenix Project. Long book, 14 hours 😅`}</p>
    <p>{`Here's what I learned about "managing IT systems"`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`On my run today I finally finished The Phoenix Project. Long book, 14 hours 😅`}<br parentName="p"></br><br parentName="p"></br>{`Here's what I learned about "managing IT systems"`}<br parentName="p"></br><br parentName="p"></br>{`👇 `}<a parentName="p" {...{
          "href": "https://t.co/dU2DHu17ZZ"
        }}>{`pic.twitter.com/dU2DHu17ZZ`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1130254521966317569"
      }}>{`May 19, 2019`}</a></blockquote>
    <p>{`My edition had something like 3 or 4 chapters of The Devops Handbook tacked on the end. That was pretty neat.`}</p>
    <p>{`Yes, The Phoenix Project is ultimately a devops book kinda aimed at traditional businesses that don't consider IT a core competency.`}</p>
    <p>{`It's 2019. IT is always a core competency.`}</p>
    <hr></hr>
    <p>{`You can learn a lot from devops even if you're a dev not an ops.`}</p>
    <p>{`Like The Goal, The Phoenix Project is also based on the theory of constraints.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`And this is how you make anythibg faster `}<a parentName="p" {...{
          "href": "https://t.co/g4LMcOCCMJ"
        }}>{`pic.twitter.com/g4LMcOCCMJ`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1122733989012226049"
      }}>{`April 29, 2019`}</a></blockquote>
    <hr></hr>
    <p>{`Your goal when managing the IT process from start – requirements collection – to finish – delivering value in production – should be to improve throughput. It's okay to slow down parts of the system if that improves overall throughput.`}</p>
    <hr></hr>
    <p>{`Your project isn't done when you're dev complete and you toss your code over the wall.`}</p>
    <p>{`Your project is done when it's in production. It is your job as developer to help with that part. Move config into code. Move infrastructure into code. Develop on production-like systems.`}</p>
    <hr></hr>
    <p>{`Reducing batch sizes improves throughput.`}</p>
    <p>{`The smaller and less disruptive that deploys are, the more of them you can do.`}</p>
    <p>{`The more you deploy, the faster you can see if it's working.`}</p>
    <p>{`The faster you see if it works, the faster you can experiment.`}</p>
    <p>{`The faster you experiment, the better you respond to the market.`}</p>
    <p>{`1 deploy per feature is best. If it breaks, you roll back 1 feature and the rest keeps chugging along.`}</p>
    <hr></hr>
    <p>{`Automate deployments. Humans are slow and error prone.`}</p>
    <p>{`Let humans focus on designing and improving the system that does the tedious parts automatically.`}</p>
    <hr></hr>
    <p>{`Your job is to deliver business value.`}</p>
    <p>{`Engineers like to forget that.`}</p>
    <hr></hr>
    <p>{`Kanban boards are the best tool we know to visualize how well the system works as a whole.`}</p>
    <p>{`Tasks that aren't on the board don't exist. Each work center should have a single point of entry for new work.`}</p>
    <hr></hr>
    <p>{`There are 4 types of work:`}</p>
    <ul>
      <li parentName="ul">{`the work itself`}</li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`work that manages work`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`changes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`putting things in production`}</p>
      </li>
    </ul>
    <p>{`I think? This was difficult to tease out in this format.`}</p>
    <hr></hr>
    <p>{`Your clients might get excited that you can take on a whole lot of work. But what they really want is a predictable delivery timeline.`}</p>
    <p>{`WIP is killer. Avoid.`}</p>
    <hr></hr>
    <p>{`Overall, The Phoenix Project was a great read. The characters were relatable, the lessons were easy to discern, and it's changed the way I think about my work.`}</p>
    <p>{`You should give it a read 🤘`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      